import { useDataChange, useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)
  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let filters = useDataValue({
    context: 'tab',
    path: 'selected.filters',
    viewPath: props.viewPath,
  })

  let id = useDataValue({
    context: 'board',
    path: 'id',
    viewPath: props.viewPath,
  })

  let location = useDataValue({
    context: 'global',
    path: 'current_location',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.selected.board_id = id
      next.selected.has_changes = false
      next.selected.board_submenu_tab_id = 'Board'
      // reset open task
      next.selected.task_overlay.show_board = false
      next.selected.task_overlay.task_id = null
      next.selected.task_overlay.open = false
      // preserve some filters
      next.selected.filters = {
        ...filters,
        filterData: {
          ...filters.filterData,
          locations: filters?.filterData?.locations ?? [
            { id: location._id, _id: location._id, name: location.name },
          ],
          stages: [],
          patients: [],
          assignees: [],
        },
      }
    })

    // default screen for a new board
    setFlowTo(
      normalizePath(
        props.viewPath,
        `../../../../../Content/Board/Content/Main/Board`
      )
    )
  }
}
